import React from 'react';
import usePcrV2 from '../../hooks/usePcrV2';
import { useGetEpdElectricity } from 'services/api/queries';
import { ElectricityDataModel } from 'types/types';
import ElectricityGridPdf from './ElectricityGridPdf';
import { DataTableStyled } from '../StyledGrid';
import { Column } from 'primereact/column';
import { getElectricityHeaderText } from './ElectricityList';
import { EpdVersionHistoryData } from '../../version-history/utils/EpdVersionHistoryDataContext';
import { ComparerRowsGetter } from '../../version-compare/VersionCompareKeyValueGrid';
import { SummaryGridRow } from '../../version-history/VersionHistorySummaryGrid';

const ElectricityListPdf: React.FunctionComponent<{
  epdVersionId: string;
  className?: string;
}> = ({ epdVersionId, className }) => {
  const electricityItems = useGetEpdElectricity(epdVersionId).data;

  const isPcrV2 = usePcrV2();

  const hasElectricityItems = Array.isArray(electricityItems) && electricityItems.length > 0;

  if (!hasElectricityItems) return null;

  return electricityItems.map((electricityItem: ElectricityDataModel) => {
    const { electricityUsedInProcessName, isDefault } = electricityItem;
    const headerText = getElectricityHeaderText(isPcrV2, electricityUsedInProcessName, isDefault);
    return (
      <React.Fragment key={electricityItem.ord}>
        <ElectricityGridPdf className={className} headerText={headerText} data={electricityItem} isPcrV2={isPcrV2} />

        {isPcrV2 && electricityItem?.residualElectricityMixCalculationMethod && (
          <DataTableStyled
            dataKey="name"
            value={[
              {
                name: 'Method used to calculate residual electricity mix',
                value: electricityItem.residualElectricityMixCalculationMethod,
              },
            ]}
            showHeaders={false}
            showGridlines
          >
            <Column field="name" style={{ width: '30%', verticalAlign: 'top' }} />
            <Column field="value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }} />
          </DataTableStyled>
        )}
      </React.Fragment>
    );
  });
};

export const getElectricityMethodRows: ComparerRowsGetter = (
  data: EpdVersionHistoryData,
  isPcrV2: boolean,
  additionalData?: ElectricityDataModel
): SummaryGridRow[] => {
  const commentRow: SummaryGridRow[] = [];
  if (isPcrV2 && additionalData?.residualElectricityMixCalculationMethod) {
    commentRow.push({
      ord: 1,
      name: 'Method used to calculate residual electricity mix',
      value: additionalData?.residualElectricityMixCalculationMethod,
    });
  }
  return commentRow;
};

export default ElectricityListPdf;
